import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

// PrimeNG imports
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';

// Import the interface from the dialog component
import { LearnMore } from '../learn-more-dialog/learn-more-dialog.component';

@Component({
  selector: 'app-learn-more-item',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    ButtonModule,
    CardModule
  ],
  templateUrl: './learn-more-item.component.html',
  styleUrls: ['./learn-more-item.component.css']
})
export class LearnMoreItemComponent {
  @Input({ required: true }) item!: LearnMore;
  @Input({ required: true }) index!: number;
  @Output() edit = new EventEmitter<{ item: LearnMore; index: number }>();
  @Output() remove = new EventEmitter<{ item: LearnMore; index: number }>();

  onEdit(): void {
    this.edit.emit({ item: this.item, index: this.index });
  }

  onRemove(): void {
    this.remove.emit({ item: this.item, index: this.index });
  }
}